export enum ChildAccountStatus {
    Invited = 'Invited',
    Resend = 'Resend',
    Active = 'Active'
}